'use strict';
module.exports = require('./Paginator.vue');